"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inViewpoint = void 0;
/**
 * Проверяет вхождение элемента в область просмотра браузера
 */
function inViewpoint(element) {
    const bottomBorder = window.innerHeight + window.scrollY;
    const elementOffset = element.getBoundingClientRect().top + window.scrollY;
    return elementOffset < bottomBorder;
}
exports.inViewpoint = inViewpoint;
